var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvaluated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 24.6265L26.1333 25.1465C25.64 25.2665 25.2533 25.6398 25.1466 26.1332L24.68 28.0932C24.4266 29.1598 23.0666 29.4932 22.36 28.6532L18.3733 24.0665C18.0533 23.6932 18.2266 23.1065 18.7066 22.9865C21.0666 22.4132 23.1866 21.0932 24.7466 19.2132C25 18.9065 25.4533 18.8665 25.7333 19.1465L28.6933 22.1065C29.7066 23.1198 29.3466 24.3865 28.3333 24.6265Z",
    fill: "url(#paint0_linear_1695_34978)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59997 24.6265L5.79997 25.1465C6.29331 25.2665 6.67997 25.6398 6.78664 26.1332L7.25331 28.0932C7.50664 29.1598 8.86664 29.4932 9.57331 28.6532L13.56 24.0665C13.88 23.6932 13.7066 23.1065 13.2266 22.9865C10.8666 22.4132 8.74664 21.0932 7.18664 19.2132C6.93331 18.9065 6.47997 18.8665 6.19997 19.1465L3.23997 22.1065C2.22664 23.1198 2.58664 24.3865 3.59997 24.6265Z",
    fill: "url(#paint1_linear_1695_34978)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66699C10.84 2.66699 6.66663 6.84033 6.66663 12.0003C6.66663 13.9337 7.23996 15.707 8.22663 17.187C9.66663 19.3203 11.9466 20.827 14.6 21.2137C15.0533 21.2937 15.52 21.3337 16 21.3337C16.48 21.3337 16.9466 21.2937 17.4 21.2137C20.0533 20.827 22.3333 19.3203 23.7733 17.187C24.76 15.707 25.3333 13.9337 25.3333 12.0003C25.3333 6.84033 21.16 2.66699 16 2.66699ZM20.08 11.707L18.9733 12.8137C18.7866 13.0003 18.68 13.3603 18.7466 13.627L19.0666 15.0003C19.32 16.0803 18.7466 16.507 17.7866 15.9337L16.4533 15.147C16.2133 15.0003 15.8133 15.0003 15.5733 15.147L14.24 15.9337C13.28 16.4937 12.7066 16.0803 12.96 15.0003L13.28 13.627C13.3333 13.3737 13.24 13.0003 13.0533 12.8137L11.92 11.707C11.2666 11.0537 11.48 10.4003 12.3866 10.2537L13.8133 10.0137C14.0533 9.97366 14.3333 9.76033 14.44 9.54699L15.2266 7.97366C15.6533 7.12033 16.3466 7.12033 16.7733 7.97366L17.56 9.54699C17.6666 9.76033 17.9466 9.97366 18.2 10.0137L19.6266 10.2537C20.52 10.4003 20.7333 11.0537 20.08 11.707Z",
    fill: "url(#paint2_linear_1695_34978)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1695_34978",
    x1: 23.7537,
    y1: 18.958,
    x2: 23.7537,
    y2: 29.1267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8A6",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#008578"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1695_34978",
    x1: 8.17958,
    y1: 18.958,
    x2: 8.17958,
    y2: 29.1267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8A6",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#008578"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1695_34978",
    x1: 16,
    y1: 2.66699,
    x2: 16,
    y2: 21.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8A6",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#008578"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluated);
export default __webpack_public_path__ + "static/media/evaluated.84ef5b3cdea5ed5d9a67ccf3e1c1db47.svg";
export { ForwardRef as ReactComponent };